/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestLoginCodeResponse
 */
export interface RequestLoginCodeResponse {
    /**
     * 
     * @type {string}
     * @memberof RequestLoginCodeResponse
     */
    loginCodeRequestId: string;
}

/**
 * Check if a given object implements the RequestLoginCodeResponse interface.
 */
export function instanceOfRequestLoginCodeResponse(value: object): value is RequestLoginCodeResponse {
    if (!('loginCodeRequestId' in value) || value['loginCodeRequestId'] === undefined) return false;
    return true;
}

export function RequestLoginCodeResponseFromJSON(json: any): RequestLoginCodeResponse {
    return RequestLoginCodeResponseFromJSONTyped(json, false);
}

export function RequestLoginCodeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestLoginCodeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'loginCodeRequestId': json['loginCodeRequestId'],
    };
}

export function RequestLoginCodeResponseToJSON(json: any): RequestLoginCodeResponse {
    return RequestLoginCodeResponseToJSONTyped(json, false);
}

export function RequestLoginCodeResponseToJSONTyped(value?: RequestLoginCodeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'loginCodeRequestId': value['loginCodeRequestId'],
    };
}

